var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1096 3.49487C10.2748 4.61253 11.4094 5.70094 12.5626 6.80712C12.4501 6.92783 12.3705 7.01879 12.2851 7.10416C10.2068 9.17873 8.13053 11.2554 6.04508 13.3227C5.84528 13.5208 5.60503 13.695 5.35384 13.8217C4.01585 14.4964 2.66872 15.1525 1.3244 15.8144C0.842494 16.0516 0.499035 16.0321 0.221538 15.754C-0.0530485 15.4789 -0.0725256 15.1289 0.16391 14.6508C0.844 13.2761 1.52238 11.9006 2.2091 10.5291C2.29705 10.3535 2.40809 10.1784 2.54583 10.0403C4.70839 7.87336 6.87717 5.71252 9.04484 3.55069C9.07968 3.51604 9.11954 3.48639 9.1096 3.49487Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7246 5.62224C12.6199 4.51257 11.5043 3.39181 10.3413 2.22353C10.9554 1.63714 11.5503 0.957498 12.2556 0.423129C13.1914 -0.285867 14.5696 -0.0665089 15.3494 0.802539C16.1618 1.70793 16.2036 3.0773 15.3939 3.9781C14.87 4.56089 14.2775 5.08218 13.7246 5.62224Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5844 15.9977C10.4207 15.9976 9.25696 16.0045 8.09345 15.995C7.41457 15.9894 7.00334 15.4368 7.25172 14.8777C7.42069 14.4974 7.74829 14.3805 8.14174 14.3814C9.38044 14.3842 10.6192 14.382 11.8579 14.382C12.934 14.382 14.0102 14.3758 15.0861 14.3846C15.759 14.3901 16.1756 14.9491 15.9279 15.505C15.7588 15.8847 15.4326 16.001 15.0377 15.9995C13.8867 15.9949 12.7355 15.9978 11.5844 15.9977Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterEditPen);
export default __webpack_public_path__ + "static/media/footer-edit-pen.afe3b3431370a0f9d87c6bb2c872f3ef.svg";
export { ForwardRef as ReactComponent };